<template>
  <div class="e-query">
    <div class="w">
      <p class="title">证书查询</p>
      <el-form :model="form" :rules="rules" ref="queryForm">
        <el-form-item class="number" prop="number">
          <el-input type="text" placeholder="证书编号" v-model="form.number" clearable/>
        </el-form-item>
        <el-form-item class="name" prop="name">
          <el-input type="text" placeholder="持证人姓名" v-model="form.name" clearable/>
        </el-form-item>
        <el-form-item class="phone" prop="phone">
          <el-input type="text" placeholder="手机号" v-model="form.phone" clearable/>
        </el-form-item>
        <el-form-item class="phoneCode" prop="phoneCode">
          <el-input type="text" placeholder="手机验证码" v-model="form.phoneCode" clearable>
            <template slot="append">
              <p @click="sendMobileCode">
                {{ getCodeStatus }}
              </p>
            </template>
          </el-input>
          <el-button @click.stop="submitForm('queryForm')">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="query-certificate" v-if="queryInfo" v-loading="loading">
      <div class="info">
        <p>
          <!-- eslint-disable-next-line -->
          <span class="label">姓　　名</span>
          <span class="content">{{ queryInfo.truename }}</span>
        </p>
        <p>
          <span class="label">证书编号</span>
          <span class="content">{{ queryInfo.certifnum }}</span>
        </p>
        <p>
          <span class="label">课程名称</span>
          <span class="content">{{ queryInfo.classtitle }}</span>
        </p>
        <p>
          <span class="label">发证日期</span>
          <span class="content">{{ queryInfo.certitime | filterDate }}</span>
        </p>
      </div>
      <div class="query-box">
        <certificate
          class="query-img"
          width="850"
          :content="getCertificateContent"
          :name="queryInfo.truename"
          :time="queryInfo.certitime | fixDate"
          :code="queryInfo.certifnum"
          :teachers="queryInfo.teachers"
          :type="queryInfo.type === 1 ? 'online' : 'outline'"
        />
      </div>
    </div>
    <div v-if="queryInfo === null">
      <p>没有查询到相关证书</p>
    </div>
  </div>
</template>

<script>
import Certificate from '@/components/certificate'
import api from '@/api'

export default {
  data () {
    let checkPhone = function (rule, val, cb) {
      if (!/^1[0-9]{10}$/.test(val)) {
        cb(new Error('请输入正确的手机号'))
      } else {
        cb()
      }
    }
    return {
      queryInfo: undefined,
      form: {
        number: '',
        name: '',
        phone: '',
        phoneCode: '',
      },
      rules: {
        number: [
          { required: true, message: '证书编号为必填', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '姓名为必填', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号为必填', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        phoneCode: [
          { required: true, message: '手机验证码为必填', trigger: 'blur' },
        ],
      },
      remainTime: 0,
      waitingTime: 10,
      sending: false,
      loading: false
    }
  },
  components: {
    Certificate
  },
  computed: {
    getCodeStatus () {
      if (this.remainTime > 0) {
        return `${this.remainTime}秒后可发送`
      } else {
        return '获取验证码'
      }
    },
    getCertificateContent () {
      const startTime = this.$options.filters.fixDate(this.queryInfo.starttime)
      const endTime = this.$options.filters.fixDate(this.queryInfo.endtime).replace(startTime.slice(0, 5), '') // 结束时间等于发证时间
      const type = this.queryInfo.type === 1 ? '学院' : '线下培训'
      return `于${startTime}至${endTime}参加“${this.queryInfo.classtitle}”${type}课程，经考核成绩${this.queryInfo.rank}，特发此证。`
    }
  },
  filters: {
    filterDate (timestamp) {
      return new Date(timestamp * 1000 + 8 * 3600 * 1000).toISOString().split('T')[0]
    },
    fixDate (timestamp) {
      return new Date(timestamp * 1000 + 8 * 3600 * 1000).toISOString().split('T')[0].replace('-','年').replace('-', '月') + '日'
      // 8 * 3600 * 1000 为8小时时差
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.queryCertificate()
        } else {
          return false
        }
      })
    },
    countTime () {
      if (this.remainTime > 0) { return }
      const startDate = new Date()
      this.remainTime = this.waitingTime
      const timer = setInterval(() => {
        const seconds = (new Date() - startDate)/1000
        this.remainTime = parseInt(this.waitingTime - seconds)
        if (this.remainTime <= 0) {
          this.remainTime = 0
          clearInterval(timer)
        }
      }, 250)
    },
    sendMobileCode () {
      if (this.remainTime > 0) { return }
      this.$refs.queryForm.validateField('phone', async (val) => {
        if (!val && !this.sending) {
          this.sending = true
          let resp = await api.sendMobileCode(this.form.phone)
          if (resp.data.status === 'ok') {
            this.$message.success('发送成功！')
            this.countTime()
          } else {
            this.$message.error(resp.data.msg)
            this.countTime()
          }
          this.sending = false
        }
      })
    },
    async queryCertificate () {
      this.loading = true
      let resp = await api.queryCertificate({
        mobilecode: this.form.phoneCode,
        truename: this.form.name,
        certifnum: this.form.number,
        mobile: this.form.phone
      })
      if (resp.data.status === 'ok') {
        this.queryInfo = resp.data.cert
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.e-query{
  background-color: #F3F5F7;
  height: 180px;
  width: 100%;
  .w{
    width: 1200px;
    margin: 0 auto;
    .title{
      padding-top: 50px;
      margin-bottom: 20px;
      font-size: 20px;
      line-height: 26px;
      font-weight: 700;
    }
    /deep/ .el-form{
      display: flex;
      justify-content: space-between;
      .el-form-item{
        display: inline-block;
        width: 278px;
        &.phoneCode{
          width: 303px;
          .el-form-item__content{
            .el-input{
              input{
                width: 220px;
                border-right: none;
              }
            }
          }
          .el-input-group__append{
            background-color: #fff;
            color: #FF6565;
            cursor: pointer;
            padding: 0;
            width: 111px;
            text-align: center;
            position: absolute;
            border: none;
            line-height: 43px;
            right: 0;
            top: 1px;
          }
          button{
            width: 83px;
            background-color: #FF6565;
            height: 45px;
            border: none;
            outline: none;
            text-align: center;
            color: white;
            border-radius: 0;
          }
        }
        &.code{
          .code-img{
            width: 113px;
            height: 45px;
            background: #f91;
            display: inline-block;
          }
          .el-form-item__content{
            display: flex;
            .el-input{
              input{
                width: 100px;
              }
            }
          }
        }
        .el-form-item__content{
          display: flex;
          .el-input{
            width: auto;
            .el-input__inner{
              border-radius: 1px;
              width: 278px;
              height: 45px;
              line-height: 45px;
            }
          }
        }
      }
    }
  }
  .query-certificate{
    .info{
      padding-top: 50px;
      padding-bottom: 40px;
      width: 900px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      p{
        span{
          display: inline-block;
          font-size: 16px;
          line-height: 21px;
          &.label{
            width: 65px;
            color: #7A7A7A;
            margin-right: 25px;
          }
          &.content{
            color: #5C5F63;
            font-weight: 700;
          }
        }
      }
    }
  }
  .query-box{
    width: 850px;
    height: 600px;
    margin: 0 auto;
    margin-bottom: 100px;
    .query-img{
      display: block;
    }
  }
}
</style>


<style lang="scss" scoped>
</style>
